var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherMaster(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11H14a1 1 0 0 1-1-1V6.5a4.5 4.5 0 1 1 4.5 4.5zM15 9h2.5A2.5 2.5 0 1 0 15 6.5zM17.5 22a4.51 4.51 0 0 1-4.5-4.5V14a1 1 0 0 1 1-1h3.5a4.5 4.5 0 0 1 0 9zM15 15v2.5a2.5 2.5 0 1 0 2.5-2.5zM10 11H6.5A4.5 4.5 0 1 1 11 6.5V10a1 1 0 0 1-1 1zM6.5 4a2.5 2.5 0 0 0 0 5H9V6.5A2.5 2.5 0 0 0 6.5 4zM6.5 22a4.5 4.5 0 0 1 0-9H10a1 1 0 0 1 1 1v3.5A4.51 4.51 0 0 1 6.5 22zm0-7A2.5 2.5 0 1 0 9 17.5V15z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherMaster);
export default __webpack_public_path__ + "static/media/other-master.3f1ea15293e4b9935e768e51ac7aab1a.svg";
export { ForwardRef as ReactComponent };